import { render, staticRenderFns } from "./buyOrderPay.vue?vue&type=template&id=2f4bd5b9&scoped=true&"
import script from "./buyOrderPay.vue?vue&type=script&lang=js&"
export * from "./buyOrderPay.vue?vue&type=script&lang=js&"
import style0 from "./buyOrderPay.vue?vue&type=style&index=0&id=2f4bd5b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bd5b9",
  null
  
)

export default component.exports